<template>
  <div class="pay-confirm">
    <div class="content">
      <div class="l">
        <div class="table-content">
          <div class="header">
            <div class="label">{{ $t('pay_confirm_zdlb') }}</div>
            <div class="tap" @click="billIsOpen = !billIsOpen">
              <div class="text">{{ $t('pay_confirm_zhan_kai') }}</div>
              <div class="icon icon-zhankai" :class="{ rotate: billIsOpen }"></div>
            </div>
          </div>
          <div class="slider" v-show="billIsOpen">
            <div class="search-content">
              <el-form :inline="true" @submit.native.prevent>
                <el-form-item v-if="editable && !isLockBill">
                  <el-button type="warning" @click="onAddBill">
                    <i class="icon icon-tianjia"></i>
                    {{ $t('pay_confirm_tjzd') }}
                  </el-button>
                </el-form-item>
                <el-form-item style="float: right; margin-right: 0">
                  <custom-column ref="column"></custom-column>
                </el-form-item>
                <!-- <el-form-item style="float:right;">
                  <search-input
                    v-model="formSearch.search"
                    placeholder="请输入"
                    @fetch="onPageChange({page:1})"
                  ></search-input>
                </el-form-item> -->
              </el-form>
            </div>
            <div class="table-bd">
              <custom-table
                tableCode="portal_pay_confirm_bill"
                height="100%"
                :stripe="true"
                :data="list1"
                @column="setColumn"
                columnRef="column"
                :slots="['termNum', 'money', 'action']"
                @filter="filterChange"
                @sort="sortChange"
                :filterArr="filterArr1"
              >
                <template v-slot:termNum="scope">
                  <div>{{ formatTermNum(scope.row) }}</div>
                </template>
                <template v-slot:money="scope">
                  <div class="money">
                    {{ scope.row.paymentAmount || 0 }} / {{ scope.row.overdueAmount || 0 }} / {{ scope.row.depositFee || 0 }} /
                    {{ scope.row.breakAmount || 0 }}
                  </div>
                </template>
                <template v-slot:action="scope">
                  <span>
                    <el-button :disabled="!editable || isLockBill" type="text" size="mini" @click="delBill(scope.row)">{{ $t('com_delete') }}</el-button>
                  </span>
                </template>
              </custom-table>
            </div>
            <div class="page-footer">
              <custom-pagination :total="billList.length" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange" radius></custom-pagination>
            </div>
          </div>
        </div>
        <div class="table-content">
          <div class="header">
            <div class="label">{{ $t('pay_confirm_fu_kuan_xin_xi') }}</div>
            <div class="tap" @click="payInfoIsOpen = !payInfoIsOpen">
              <div class="text">{{ $t('pay_confirm_zhan_kai_1') }}</div>
              <div class="icon icon-zhankai" :class="{ rotate: payInfoIsOpen }"></div>
            </div>
          </div>
          <div class="slider" v-show="payInfoIsOpen">
            <div class="search-content">
              <el-form :inline="true" @submit.native.prevent>
                <el-form-item v-if="editable">
                  <el-button type="warning" @click="onAddPayInfo" :disabled="!billList.length">
                    <i class="icon icon-tianjia"></i>
                    {{ $t('pay_confirm_fu_kuan_xin_xi_1') }}
                  </el-button>
                </el-form-item>
                <el-form-item style="float: right; margin-right: 0">
                  <custom-column ref="column2"></custom-column>
                </el-form-item>
              </el-form>
            </div>
            <div class="table-bd">
              <custom-table
                tableCode="portal_pay_confirm_pay_info"
                height="100%"
                :stripe="true"
                :data="tradeList"
                @column="setColumn"
                columnRef="column2"
                :slots="['payInfo', 'tradeResult', 'action']"
                @filter="filterChange"
                @sort="sortChange"
                :filterArr="type === 'watch' ? ['action'] : []"
              >
                <template v-slot:tradeResult="scope">
                  <div class="img-preview" v-if="scope.row.previewImg">
                    <el-image style="width: 64px; height: 64px" :src="scope.row.previewImg" :preview-src-list="scope.row.srcList" fit="contain"></el-image>
                  </div>
                  <span v-else>-{{ scope.row.previewImg }}</span>
                </template>
                <template v-slot:payInfo="scope">
                  <span class="pay-info" v-if="isAccountPay(scope.row)">
                    <div class="item">
                      <div class="key">{{ $t('pay_confirm_zhmc') }}:</div>
                      <div class="val">{{ scope.row.payInfo.accountName }}</div>
                    </div>
                    <div class="item">
                      <div class="key">{{ $t('pay_confirm_yhzh') }}:</div>
                      <div class="val">{{ scope.row.payInfo.account }}</div>
                    </div>
                    <div class="item">
                      <div class="key">{{ $t('pay_confirm_kai_hu_yin_hang') }}:</div>
                      <div class="val">{{ scope.row.payInfo.bank }}</div>
                    </div>
                    <div class="item">
                      <div class="key">{{ $t('pay_confirm_zzbz') }}:</div>
                      <div class="val">{{ scope.row.payInfo.remark }}</div>
                    </div>
                  </span>
                  <span class="pay-info" v-else>
                    <div class="item">
                      <div class="key">{{ $t('pay_confirm_shou_kuan_ren') }}:</div>
                      <div class="val">{{ scope.row.sellerAccount }}</div>
                    </div>
                  </span>
                </template>
                <template v-slot:action="scope">
                  <span>
                    <el-button :disabled="!editable" type="text" size="mini" @click="onEditPayInfo(scope.$index)">{{ $t('com_edit') }}</el-button>
                    <el-button :disabled="!editable" type="text" size="mini" @click="onDelPayInfo(scope.$index)">{{ $t('com_delete') }}</el-button>
                  </span>
                </template>
              </custom-table>
            </div>
            <!-- <div class="page-footer">
              <custom-pagination
                :total="tradeList.length"
                :page="formSearch2.pageNum"
                :size="formSearch2.pageSize"
                @change="onPageChange2"
                radius
              ></custom-pagination>
            </div> -->
          </div>
        </div>
      </div>
      <div class="r">
        <div class="pay-info">
          <div class="title">{{ $t('pay_confirm_zfxq') }}</div>
          <div class="order-code">
            <div class="label">{{ $t('pay_confirm_ddbh') }}:</div>
            <div class="value">{{ registerMsg.paymentCode }}</div>
          </div>
          <div class="group-list">
            <div class="group" v-if="editable">
              <div class="rest">
                <div class="label">{{ $t('pay_confirm_zu_lin_yu_e') }}:</div>
                <div class="value">￥{{ registerMsg.balance }}</div>
                <div class="use-rest">
                  <div class="use-label">{{ $t('pay_confirm_shi_yong') }}</div>
                  <div class="use-cb">
                    <el-checkbox v-model="useRest" :disabled="!editable"></el-checkbox>
                  </div>
                </div>
              </div>
            </div>
            <div class="group">
              <div class="amount">
                <div class="should-pay">{{ $t('pay_confirm_ying_fu_jin_e') }}:￥{{ payableTotal }}</div>
                <div class="details">
                  <div class="item">
                    <div class="key">{{ $t('pay_confirm_zu_lin_yu_e_1') }}</div>
                    <div class="val">￥{{ expectUseRest }}</div>
                  </div>
                  <div class="item">
                    <div class="key">{{ $t('pay_confirm_dgzz') }}</div>
                    <div class="val">￥{{ publicAmount }}</div>
                  </div>
                  <div class="item">
                    <div class="key">{{ $t('pay_confirm_xian_jin_zhi_fu') }}</div>
                    <div class="val">￥{{ cashAmount }}</div>
                  </div>
                </div>
                <div class="actual-pay">
                  <div class="key">{{ $t('pay_confirm_shi_fu_jin_e') }}：</div>
                  <div class="val">￥{{ total }}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="btn-content">
            <el-button v-if="editable" type="warning" class="btn" @click="onConfirm" :disabled="!submitVisible">{{ $t('pay_confirm_ti_jiao') }}</el-button>
            <el-button v-if="editable" type="info" class="btn" @click="onStore" :disabled="!submitVisible">{{ $t('pay_confirm_zan_cun') }}</el-button>
          </div>
        </div>
      </div>
    </div>
    <add-bill-dialog v-if="addBillVisible" @close="addBillVisible = false" :model="addBillModel" :filterBillIdList="addBillModel.filterBillIdList" @confirm="onAddBillConfirm"></add-bill-dialog>
    <!-- <pay-info-dialog
      v-if="payInfoVisible"
      @close="payInfoVisible = false"
      :model="payInfoModel"
      :orderNum="orderNum"
      :totalAmount="totalAmount"
      @add="onAddPayInfoHandler"
      @edit="onEditPayInfoHandler"
      :listLen="tradeList.length"
    ></pay-info-dialog> -->
    <pay-type-dialog v-if="payTypeDialogVisible" @close="payTypeDialogVisible = false" :model="{ title: $t('pay_confirm_fu_kuan_fang_shi') }" @confirm="onPayTypeConfirm"></pay-type-dialog>
    <add-pay-info-public-step1-dialog
      v-if="addPayInfoPublicStep1DialogVisible"
      @close="addPayInfoPublicStep1DialogVisible = false"
      :model="payInfoModel"
      :totalAmount="totalAmount"
      :paymentCode="registerMsg.paymentCode"
      @confirm="step1Confirm"
    ></add-pay-info-public-step1-dialog>
    <add-pay-info-public-step2-dialog
      v-if="addPayInfoPublicStep2DialogVisible"
      @close="addPayInfoPublicStep2DialogVisible = false"
      :model="payInfoModel"
      :totalAmount="totalAmount"
      :paymentCode="registerMsg.paymentCode"
      @edit="onEditPayInfoHandler"
      @add="onAddPayInfoHandler"
    ></add-pay-info-public-step2-dialog>
    <add-pay-info-pay-msg-dialog
      v-if="addPayInfoPayMsgDialogVisible"
      @close="addPayInfoPayMsgDialogVisible = false"
      :model="payInfoModel"
      :totalAmount="totalAmount"
      :orderNum="registerMsg.paymentCode"
      @add="onAddPayInfoHandler"
      @edit="onEditPayInfoHandler"
    ></add-pay-info-pay-msg-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import addBillDialog from './children/add_bill_dialog.vue';
// import payInfoDialog from './children/pay_info_dialog.vue';
import mixins from './children/mixins';
import payTypeDialog from './children/pay_type_dialog.vue';
import addPayInfoPublicStep1Dialog from './children/add_pay_info_public_step1_dialog.vue';
import addPayInfoPublicStep2Dialog from './children/add_pay_info_public_step2_dialog.vue';
import addPayInfoPayMsgDialog from './children/add_pay_info_pay_msg_dialog.vue';

/**
 * 实际是付款登记，只是被要求名为确认付款
 */

// function mockData(len) {
//   const arr = new Array(len).fill(0);
//   return arr.map((_, index) => ({
//     id: index
//   }));
// }

// i18n-lang-component
// pay_confirm_zdlb: 账单列表// pay_confirm_zhan_kai: 展开// pay_confirm_tjzd: 添加账单// pay_confirm_fu_kuan_xin_xi: 付款信息// pay_confirm_zhan_kai_1: 展开// pay_confirm_fu_kuan_xin_xi_1: 付款信息// pay_confirm_zhmc: 账户名称// pay_confirm_yhzh: 银行账号// pay_confirm_kai_hu_yin_hang: 开户银行// pay_confirm_zzbz: 转账备注// pay_confirm_shou_kuan_ren: 收款人// pay_confirm_zfxq: 支付详情// pay_confirm_ddbh: 订单编号// pay_confirm_zu_lin_yu_e: 租赁余额// pay_confirm_shi_yong: 使用// pay_confirm_ying_fu_jin_e: 应付金额// pay_confirm_zu_lin_yu_e_1: 租赁余额// pay_confirm_dgzz: 对公转账// pay_confirm_xian_jin_zhi_fu: 现金支付// pay_confirm_shi_fu_jin_e: 实付金额// pay_confirm_ti_jiao: 提交// pay_confirm_zan_cun: 暂存// pay_confirm_fu_kuan_fang_shi: 付款方式// pay_confirm_bjfkxx: 编辑付款信息// pay_confirm_tjfkxx: 添加付款信息// pay_confirm_bjfkxx_1: 编辑付款信息// pay_confirm_tjfkxx_1: 添加付款信息// pay_confirm_tjzd_1: 添加账单// pay_confirm_yfjehjbnxy: 应付金额合计不能小于0// pay_confirm_yfjehjbnxy_1: 应付金额合计不能小于0// pay_confirm_zdlbbnwk: 账单列表不能为空// pay_confirm_qxzfkxx: 请选择付款信息// pay_confirm_qxzfkxx_1: 请选择付款信息

export default {
  name: 'payConfirm',
  mixins: [mixins],
  components: {
    addBillDialog,
    // payInfoDialog,
    payTypeDialog,
    addPayInfoPublicStep1Dialog,
    addPayInfoPublicStep2Dialog,
    addPayInfoPayMsgDialog,
  },
  props: {},
  data() {
    return {
      // 禁用mixins中
      loadBillType: false,
      storeId: '',
      registerMsg: {
        balance: '',
        deposit: '',
        paymentCode: '',
      },
      useRest: false,
      billIsOpen: true,
      payInfoIsOpen: true,
      formSearch: {
        pageNum: 1,
        pageSize: 50,
        search: '',
      },
      formSearch2: {
        pageNum: 1,
        pageSize: 50,
      },
      billList: [],
      tradeList: [],

      addBillVisible: false,
      addBillModel: {},

      payInfoVisible: false,
      payInfoModel: {},
      firstOrderItem: {},

      editIndex: '',

      // edit: 付款登记  watch: 查看付款信息
      type: 'edit',

      // 账单列表是否进行了合并租金行
      hasMerge: false,

      payTypeDialogVisible: false,

      addPayInfoPublicStep1DialogVisible: false,
      addPayInfoPublicStep2DialogVisible: false,
      addPayInfoPayMsgDialogVisible: false,

      // 为true时，就是首付款
      isLockBill: false,
      sellerAccountList: [],
    };
  },
  computed: {
    filterArr1() {
      if (this.type === 'watch' || this.isLockBill) {
        return ['action'];
      }
      return null;
    },
    list1() {
      const { pageSize, pageNum } = this.formSearch;
      const list = [...this.billList];
      const start = (pageNum - 1) * pageSize;
      return list.splice(start, pageSize);
    },
    // list2() {
    //   const { pageSize, pageNum } = this.formSearch2;
    //   const list = [...this.tradeList];
    //   const start = (pageNum - 1) * pageSize;
    //   return list.splice(start, pageSize);
    // },
    balance() {
      return this.registerMsg.balance;
    },
    payableTotal() {
      return this.billList.reduce((total, item) => {
        const { paymentAmount } = item;
        const sum = paymentAmount;
        return sum + total;
      }, 0);
    },

    // 本次预计使用余额
    expectUseRest() {
      const payableTotal = this.payableTotal || 0;
      const tradeTotal = this.total || 0;
      const balance = this.useRest ? this.balance || 0 : 0;
      const ret = payableTotal - tradeTotal >= balance ? balance : payableTotal - tradeTotal;
      return Math.max(ret, 0);
    },

    total() {
      const key = 'totalAmount';
      const list = this.tradeList;
      return list.reduce((total, item) => total + Number(item[key] || 0), 0);
    },
    amount() {
      if (this.total !== undefined) {
        if (this.useRest) {
          return this.total + this.balance;
        }
        return this.total;
      }
      return 0;
    },
    totalAmount() {
      const payableTotal = this.payableTotal || 0;
      const amount = this.amount || 0;
      return Math.max(payableTotal - amount, 0);
    },
    orderNum() {
      return this.registerMsg.paymentCode;
    },
    // 公账金额 this.dicCodeValue.payment_class.public_account
    publicAmount() {
      const list = this.tradeList;
      if (this.dicCodeValue.payment_class) {
        const ret = list.filter(item => `${item.tradeMethod}` === `${this.dicCodeValue.payment_class.public_account}`);
        return ret.reduce((total, item) => {
          const { totalAmount = 0 } = item;
          return total + Number(totalAmount);
        }, 0);
      }
      return 0;
    },
    // 现金支付金额
    cashAmount() {
      const list = this.tradeList;
      if (this.dicCodeValue.payment_class) {
        const ret = list.filter(item => `${item.tradeMethod}` === `${this.dicCodeValue.payment_class.cash}`);
        return ret.reduce((total, item) => {
          const { totalAmount = 0 } = item;
          return total + Number(totalAmount);
        }, 0);
      }
      return 0;
    },
    submitVisible() {
      const total = this.total || 0;
      const expectUseRest = this.expectUseRest || 0;
      const payableTotal = this.payableTotal || 0;
      return payableTotal <= total + expectUseRest;
    },
    editable() {
      return this.type === 'edit';
    },
  },
  watch: {},
  filters: {},
  directives: {},
  methods: {
    // 判断是否付款类型为公账
    isAccountPay(row) {
      const ret = `${row.tradeMethod}` === `${this.dicCodeValue.payment_class.public_account}`;
      return ret;
    },
    initPayInfo(row) {
      const sellerItem = this.sellerAccountList.find(item => item.depositNumber === row.sellerAccount);
      row.payInfo = {};

      if (sellerItem) {
        // 开户行
        const bank = this.dicCodeName.bank_branch[sellerItem.bankCode] || sellerItem.bankName;

        const {
          // 支行
          depositBank,
          // 银行账号
          // depositNumber,
        } = sellerItem;

        // 账户名称
        row.payInfo.accountName = row.sellerName;
        // 银行账户
        row.payInfo.account = row.sellerAccount;
        // 开户行
        row.payInfo.bank = `${bank}${depositBank}`;
        // 转账备注
        row.payInfo.remark = row.buyerTradeRemark;
      }
    },
    // 获取收款方账户列表
    getSellerAccountList() {
      const firstItem = this.billList[0];
      return this.$getJSON(apis.PartnerBankcardListByOrgId, {
        orgId: firstItem.receivableOrgId,
      }).then((res) => {
        this.sellerAccountList = res.data;
      });
    },
    step1Confirm(data) {
      this.initPayInfo(data);
      this.tradeList.push(data);
      this.onStore(false).then(() => {
        this.getPageInfo().then(() => {
          const tradeList = this.tradeList;
          const lastNode = tradeList[tradeList.length - 1];
          this.payInfoModel = {
            title: this.$t('pay_confirm_bjfkxx'),
            type: 'edit',
            data: {
              outerItem: this.firstOrderItem,
              form: lastNode,
              orderNum: this.orderNum,
            },
          };
          this.addPayInfoPublicStep2DialogVisible = true;
        });
      });
    },
    // 付款方式选择
    onPayTypeConfirm(type) {
      this.payTypeDialogVisible = false;
      setTimeout(() => {
        this.payInfoModel = {
          title: this.$t('pay_confirm_tjfkxx'),
          type: 'add',
          data: {
            outerItem: this.firstOrderItem,
            form: {
              tradeMethod: this.tradeMethod,
            },
          },
        };
        if (type === 'account') {
          this.addPayInfoPublicStep1DialogVisible = true;
        } else {
          this.addPayInfoPayMsgDialogVisible = true;
        }
      }, 300);
    },
    getImgUrl(list) {
      const ret = {
        url: '',
        srcList: [],
      };

      if (list && list.length) {
        ret.url = this.getAttachUrl(list[0]);
        ret.srcList = list.map(item => this.getAttachUrl(item));
      }

      return ret;
    },
    onDelPayInfo(index) {
      this.tradeList.splice(index, 1);
    },
    onEditPayInfo(index) {
      this.editIndex = index;
      const row = this.tradeList[index];
      this.payInfoModel = {
        type: 'edit',
        title: this.$t('pay_confirm_bjfkxx_1'),
        data: {
          outerItem: this.firstOrderItem,
          form: row,
        },
      };

      // `${item.tradeMethod}` === `${this.dicCodeValue.payment_class.public_account}`
      // 如果当前row是现金类型，打开现金付款信息编辑dialog
      // 如果当前row是公账类型，打开工作付款信息编辑dialog
      const isAccount = `${row.tradeMethod}` === `${this.dicCodeValue.payment_class.public_account}`;
      if (isAccount) {
        this.addPayInfoPublicStep2DialogVisible = true;
      } else {
        this.addPayInfoPayMsgDialogVisible = true;
      }
    },
    onAddPayInfo() {
      // 如果付款信息为空: 则弹出付款类型选择框
      // 如果付款信息不为空：则取第一条付款信息的tradeMethod，弹出新增付款信息dialog- 对公或是现金
      // 付款信息列表
      const tradeList = this.tradeList;
      if (tradeList.length) {
        const firstItem = this.tradeList[0];
        this.payInfoModel = {
          title: this.$t('pay_confirm_tjfkxx_1'),
          type: 'add',
          data: {
            outerItem: this.firstOrderItem,
            form: {
              tradeMethod: firstItem ? firstItem.tradeMethod : this.tradeMethod,
            },
            orderNum: this.orderNum,
          },
        };
        const isAccount = `${firstItem.tradeMethod}` === `${this.dicCodeValue.payment_class.public_account}`;
        if (isAccount) {
          this.addPayInfoPublicStep1DialogVisible = true;
        } else {
          this.addPayInfoPayMsgDialogVisible = true;
        }
      } else {
        this.payTypeDialogVisible = true;
      }

      // const firstItem = this.tradeList[0];
      // this.payInfoModel = {
      //   title: '添加付款信息',
      //   type: 'add',
      //   data: {
      //     outerItem: this.firstOrderItem,
      //     form: {
      //       tradeMethod: firstItem ? firstItem.tradeMethod : this.tradeMethod
      //     },
      //     orderNum: this.orderNum
      //   }
      // };
      // this.payInfoVisible = true;

      // this.addPayInfoPublicStep1DialogVisible = true;
      // this.addPayInfoPublicStep2DialogVisible = true;
      // this.addPayInfoPayMsgDialogVisible = true;
    },
    onAddBillConfirm(rows) {
      this.billList.push(...rows);
    },
    // 删除账单
    delBill(row) {
      const item = row;
      this.billList = this.billList.filter(obj => obj.billId !== item.billId);
    },

    // 去除传入的billData中的押金字段
    initBillList(list) {
      const ret = list.map((item) => {
        const obj = {
          ...item,
        };
        obj.depositFee = 0;
        return obj;
      });
      return ret;
    },
    onAddBill() {
      const id = this.storeId;
      const rows = this.getSession(id);
      this.addBillModel = {
        title: this.$t('pay_confirm_tjzd_1'),
        type: 'add',
        data: rows[0],
        filterBillIdList: this.billList.map(item => item.billId),
      };
      this.addBillVisible = true;
    },
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
    },
    onPageChange2: function ({ page, size }) {
      this.formSearch2.pageNum = page;
      this.formSearch2.pageSize = size || this.formSearch.pageSize;
    },
    getPageInfoReqUrl() {
      const firstItem = this.firstOrderItem;
      if (firstItem.paymentCode) {
        return `${apis.paymentPaymentInfoByCode}/${firstItem.paymentCode}`;
      }
      return `${apis.paymentPaymentInfo}/${firstItem.billId}`;
    },
    getPageInfoReqData() {
      const firstItem = this.firstOrderItem;
      if (firstItem.paymentCode) {
        return {};
      }
      return { billId: firstItem.billId, receivableOrgId: firstItem.receivableOrgId, payableOrgId: firstItem.payableOrgId };
    },
    getPageInfo() {
      const reqUrl = this.getPageInfoReqUrl();
      const reqData = this.getPageInfoReqData();
      return this.$getJSON(reqUrl, reqData).then((res) => {
        const data = res.data;
        data.paymentCode = this.getPaymentCode(data);
        this.registerMsg = data;
        this.registerMsg.balance = this.getBalance(data);
        this.registerMsg.deposit = this.registerMsg.deposit || 0;
        if (data.orderViewList && data.orderViewList.length) {
          this.billList = this.formatRefundBill(data.orderViewList);
          if (this.billList.length) {
            this.firstOrderItem = this.billList[0];
          }
        }
        if (data.tradeBoList && data.tradeBoList.length) {
          data.tradeBoList.forEach((item, index) => {
            item.attachs = [];
            item.previewImg = '';
            item.srcList = [];
            this.initPayInfo(item);
            this.$getJSON(`${apis.OssAttach}/${item.tradeId}/fms.trade.certificate`).then((imgRes) => {
              item.attachs = imgRes.data;
              this.updateTradeListImg(index);
            });
          });
          this.tradeList = data.tradeBoList;
        }
        if (data.billPayment && data.billPayment.isUseBalance) {
          this.useRest = true;
        }
      });
    },
    getReqData() {
      const ret = {
        paymentCode: this.registerMsg.paymentCode,
        billPaymentCode: this.registerMsg.paymentCode,
        tradeList: this.tradeList,
        useBalance: this.useRest,
        payableOrgName: this.firstOrderItem.payableOrgName,
        payableOrgId: this.firstOrderItem.payableOrgId,
      };

      ret.billIdList = this.billList.map(item => item.billId);

      ret.isPrepayment = this.isLockBill;

      return ret;
    },
    // 暂存
    onStore(jump = true) {
      if (this.payableTotal < 0) {
        this.$message.error(this.$t('pay_confirm_yfjehjbnxy'));
        return null;
      }
      const reqData = this.getReqData();
      const reqUrl = this.getStockReqUrl(this.firstOrderItem.billType || this.firstOrderItem.billPaymentClass);

      return this.$postJSON(reqUrl, reqData, true).then(() => {
        this.$message({
          type: 'success',
          message: this.$t('com_handle_success'),
        });

        if (jump) {
          setTimeout(() => {
            this.jump(-1);
          }, 1000);
        }
      });
    },
    // 保存
    onConfirm() {
      if (this.payableTotal < 0) {
        this.$message.error(this.$t('pay_confirm_yfjehjbnxy_1'));
        return null;
      }
      if (this.billList.length === 0) {
        this.$message.error(this.$t('pay_confirm_zdlbbnwk'));
        return null;
      }
      const useRest = this.useRest;
      if (this.tradeList.length === 0) {
        if (useRest) {
          if (this.registerMsg.balance < this.payableTotal) {
            this.$message.error(this.$t('pay_confirm_qxzfkxx'));
            return null;
          }
        } else {
          this.$message.error(this.$t('pay_confirm_qxzfkxx_1'));
          return null;
        }
      }

      const reqData = this.getReqData();

      return this.$postJSON(this.getSubmitReqUrl(this.firstOrderItem.billType || this.firstOrderItem.billPaymentClass), reqData, true).then(() => {
        this.$message({
          type: 'success',
          message: this.$t('com_handle_success'),
        });

        setTimeout(() => {
          this.jump(-1);
        }, 1000);
      });
    },
    updateTradeListImg(index) {
      if (index !== undefined) {
        const item = this.tradeList[index];
        const urlItem = this.getImgUrl(item.attachs);
        item.previewImg = urlItem.url;
        item.srcList = urlItem.srcList;
        this.$set(this.tradeList, index, item);
      }
      this.tradeList.forEach((item, i) => {
        const urlItem = this.getImgUrl(item.attachs);
        item.previewImg = urlItem.url;
        item.srcList = urlItem.srcList;
        this.$set(this.tradeList, i, item);
      });
      // this.tradeList = [...this.tradeList];
    },
    onAddPayInfoHandler(row) {
      this.initPayInfo(row);
      this.tradeList.push(row);
      this.updateTradeListImg();
    },
    onEditPayInfoHandler(row) {
      this.initPayInfo(row);
      // const { pageNum, pageSize } = this.formSearch2;
      // const index = (pageNum - 1) * pageSize + this.editIndex;
      const index = this.editIndex;
      this.tradeList.splice(index, 1, row);
      this.updateTradeListImg();
    },
  },
  created() {},
  mounted() {
    this.mergeLanguage(null, 'portal_payConfirm');
    const id = this.$route.query.id;
    const type = this.$route.query.type || 'edit';
    this.storeId = id;
    const rows = this.getSession(id);
    this.billList = this.formatRefundBill(this.initBillList(rows));
    this.firstOrderItem = this.billList[0];
    this.isLockBill = !!this.firstOrderItem.isLockBill;
    this.type = type;

    this.getDictionaryCodeName('bank_branch');

    this.getDictionaryCodeValue('payment_class,bill_type', () => {
      this.getSellerAccountList().then(() => {
        this.getPageInfo();
      });
    });
  },
};
</script>

<style lang="scss" scoped>
.pay-confirm {
  padding: 24px;

  .pay-info {
    .item {
      overflow: hidden;
      &:nth-child(n + 2) {
        margin-top: 4px;
      }
      .key {
        float: left;
        font-size: 12px;
        color: #4d4d4d;
        line-height: 18px;
      }
      .val {
        overflow: hidden;
        font-size: 12px;
        color: #1a1a1a;
        line-height: 18px;
        padding-left: 16px;
        white-space: normal;
      }
    }
  }

  .custom-pagination {
    padding-left: 0;
    padding-right: 0;
  }
  > .content {
    display: flex;
    .l {
      margin-right: 24px;
      width: 0;
      flex: 1;

      .table-content {
        &:nth-child(n + 2) {
          margin-top: 24px;
        }

        background: #fff;
        border-radius: 16px;
        padding: 24px;
        padding-bottom: 0;

        > .header {
          line-height: 24px;
          padding-bottom: 24px;
          overflow: hidden;

          .label {
            float: left;
            color: #202945;
            font-size: 18px;
            font-weight: bold;
          }

          .tap {
            float: right;
            cursor: pointer;
            .text {
              float: left;
              color: #818181;
              font-size: 12px;
              font-weight: bold;
              margin-right: 3px;
            }
            .icon {
              float: left;
              color: #202945;
              font-weight: bold;
              font-size: 14px;
              transition: all;

              &.rotate {
                transform: rotate(180deg);
              }
            }
          }
        }
        .search-content {
          overflow: hidden;
        }
        .table-bd {
          height: 400px;
          width: 100%;
          padding-top: 24px;
        }
      }
    }
    .r {
      width: 380px;

      .pay-info {
        background: #fff;
        padding: 24px;
        border-radius: 4px;
        overflow: hidden;
        border-top: 4px solid #00a0d9;

        > .title {
          line-height: 40px;
          font-weight: bold;
          font-size: 18px;
        }

        .order-code {
          color: #4d4d4d;
          font-size: 14px;
          line-height: 20px;
          height: 20px;
          margin-bottom: 24px;

          .label {
            float: left;
          }
          .value {
            float: left;
            margin-left: 16px;
          }
        }

        .group {
          padding: 24px 0;
          border-top: 1px solid rgba(245, 245, 245, 1);

          &:last-child {
            border-bottom: 1px solid rgba(245, 245, 245, 1);
          }
        }

        .rest {
          overflow: hidden;
          line-height: 20px;
          .label {
            font-size: 14px;
            float: left;
            color: #4d4d4d;
          }
          .value {
            float: left;
            font-size: 14px;
            color: #1a1a1a;
            padding-left: 16px;
          }
          .use-rest {
            float: right;
            .use-label {
              float: left;
              color: #4d4d4d;
            }
            .use-cb {
              float: left;
              margin-left: 10px;
            }
          }
        }

        .amount {
          .should-pay {
            line-height: 20px;
            color: #4d4d4d;
            font-size: 14px;
            font-weight: bold;
          }

          .details {
            background: rgba(248, 249, 250, 1);
            margin-top: 24px;
            padding: 16px;
            .item {
              line-height: 20px;
              font-size: 14px;
              overflow: hidden;
              &:nth-child(n + 2) {
                margin-top: 12px;
              }
              .key {
                color: #4d4d4d;
                float: left;
              }
              .val {
                color: #1a1a1a;
                float: right;
              }
            }
          }

          .actual-pay {
            overflow: hidden;
            margin-top: 24px;
            line-height: 24px;
            font-size: 14px;
            font-weight: bold;
            .key {
              float: left;
              color: #1a1a1a;
            }
            .val {
              float: left;
              color: #00a0d9;
            }
          }
        }

        .btn-content {
          padding-top: 24px;
          padding-bottom: 10px;

          .btn {
            display: block;
            width: 100%;
            margin-left: 0 !important;
            &:nth-child(n + 2) {
              margin-top: 24px;
            }
          }
        }
      }
    }
  }
}
</style>
